import {useEffect, useState} from 'react';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';

const useEmailFieldVI = ({ getValue}) => {
    const [emails, setEmails] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState('');

    /**
     * validateInput - validate email input
     **/
    const validateInput = (() => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (inputValue === '') {
            setError('');
        } else if (emails.length === 5) {
            setError(_SYSTEM_TITLES.ToManyEmailsEmailInputError);
        } else if (emailRegex.test(inputValue)) {
            setEmails((prevEmails) => [...prevEmails, inputValue]);
            setInputValue('');
            setError('');
        } else if (!emailRegex.test(inputValue)) {
            setError(_SYSTEM_TITLES.invalidEmailInputError);
        }
    });
    const handleDeleteChip = (emailToDelete) => {
        setEmails((prevEmails) => prevEmails.filter((email) => email !== emailToDelete));
    };

    /**
     * cleanError - clean the error if the input is empty string
     * @param e - the event that triggered the input
     **/
    const cleanError = (e) => {
        e.target.value === '' && setError('');
        setInputValue(e.target.value);
    };

    useEffect(() => {
        getValue && getValue(emails);
    }, [emails]);

    return ({emails, validateInput, handleDeleteChip, error, inputValue, cleanError});
};

export default useEmailFieldVI;
